import {Box, CircularProgress} from "@mui/material";
import {Theme} from "@mui/material/styles";
import {SxProps} from "@mui/system";
import React from "react";
import {Colors} from "../colors";

interface LoadingCenterProps {
  position?: "fixed" | "absolute";
  color?: string;
  sx?: SxProps<Theme>;
}

const LoadingCenter = ({position = "fixed", color = Colors.primary._800, sx}: LoadingCenterProps) => {
  return (
    <Box
      sx={{
        position: position,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        ...sx,
      }}
    >
      <CircularProgress sx={{color}} />
    </Box>
  );
};

export default LoadingCenter;
